import Vue from 'vue';

import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
Vue.component('v-select-c', vSelect);

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate);

import Toasted from 'vue-toasted';
Vue.use(Toasted)

Vue.component('form-register-ds49', require('../pages/inscribete-ds49/Form-Register-Ds49.vue').default);

Vue.config.productionTip = false;
Vue.config.devtools = false;

if (document.getElementById("vue-form-register")) {
    new Vue({
        el: '#vue-form-register',
    });
}